import { render, staticRenderFns } from "./IbTimeInput.vue?vue&type=template&id=cfba2eea&scoped=true"
import script from "./IbTimeInput.vue?vue&type=script&lang=js"
export * from "./IbTimeInput.vue?vue&type=script&lang=js"
import style0 from "./IbTimeInput.vue?vue&type=style&index=0&id=cfba2eea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfba2eea",
  null
  
)

export default component.exports